import { useSearchParams } from "react-router-dom";
import { usePlatformShowQuery } from "@/admin/entities/platforms";
import {
  getColumnsConfig,
  getMobileColumnsConfig,
  getTextsConfig,
} from "./config";
import { getTableData, mapColumns } from "./mappers";

/**
 * Feature-специфичные хуки для управления платформами
 * Комбинируют entity-логику с UI-специфичными потребностями
 */

/**
 * Основной хук для feature управления платформами
 * Предоставляет всю необходимую конфигурацию и логику для UI компонента
 */
export function usePlatformsManagement() {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  // Используем entity хук для загрузки данных платформы
  usePlatformShowQuery(id, id === null);

  return {
    // Конфигурация таблицы
    columns: getColumnsConfig(),
    mobileColumns: getMobileColumnsConfig(),
    mapColumns,

    // Трансформация данных
    getTableData,

    // Текстовые метки
    texts: getTextsConfig(),
  };
}

/**
 * Хук для получения конфигурации колонок таблицы
 */
export function usePlatformsTableConfig() {
  return {
    columns: getColumnsConfig(),
    mapColumns,
  };
}

/**
 * Хук для получения текстовых меток интерфейса
 */
export function usePlatformsTexts() {
  return getTextsConfig();
}
